import React from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { SEO_FOR_MANAGERS } from "@/lib/seo-defs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CheckCircle2, ShieldCheck, BadgeCheck, Network, BarChart3 } from "lucide-react";

export default function ForManagersPage() {
  return (
    <div className="min-h-screen">
      <SEO {...SEO_FOR_MANAGERS} />
      <PublicHeader />
      <section className="pt-28 pb-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">Per i manager</Badge>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            Porta il tuo valore in più aziende.
          </h1>
          <p className="mt-5 text-lg text-slate-600">
            CXOORA seleziona manager con esperienza reale, capacità operative e orientamento ai risultati. Il network non è aperto automaticamente a tutti: ogni profilo viene valutato e verificato dal team CXOORA.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link to="/per-i-manager/candidati"><Button size="lg" className="bg-[#2D6BFF] hover:bg-[#1F57F2] text-white h-12 px-6" data-testid="manager-apply-cta">Candidati al network <ArrowRight size={16} className="ml-2" /></Button></Link>
            <Link to="/login"><Button size="lg" variant="outline" className="h-12 px-6">Accedi alla tua area</Button></Link>
          </div>
        </div>
      </section>
      <section className="py-12 bg-[#F6F8FC]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Cosa offre CXOORA</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              [ShieldCheck, "Profilo verificato", "Una volta validato, riceverai un badge che aumenta la credibilità verso le aziende."],
              [Network, "Opportunità mirate", "Riceverai solo richieste compatibili con i tuoi ruoli, settori e disponibilità."],
              [BadgeCheck, "Selezione meritocratica", "Le shortlist sono validate manualmente: non sei perso in mezzo a centinaia di profili."],
              [BarChart3, "Strumenti di lavoro", "Workspace condiviso con milestone, KPI, documenti e messaggistica."],
            ].map(([Icon, t, d]) => (
              <div key={t} className="flex gap-3 cxo-card p-4">
                <Icon size={20} className="text-[#2D6BFF] shrink-0" />
                <div><p className="font-semibold text-slate-900">{t}</p><p className="text-sm text-slate-600">{d}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
